class TeaserImageCarousel {
    constructor(el) {
        this.scope = el;
        this.items = el.querySelector('[data-image-items]');
        this.prevButton = el.querySelector('[data-prev-image]');
        this.nextButton = el.querySelector('[data-next-image]');
        this.items.children.length > 1 && this.buildSlider();
    }

    buildSlider(){
        this.slider = new Slider(this.scope, this.items, {controls:[this.prevButton, this.nextButton], count:[1, 1, 1]});
    }
}
document.querySelectorAll('[data-teaser-images]').forEach(el => new TeaserImageCarousel(el));

